module.exports = __webpack_public_path__ + "img/Indie-Favs-Feb-22.a6ab7d01.jpeg";